var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSegStandardTier = function SvgSegStandardTier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3a9 9 0 100 18 9 9 0 100-18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4a8 8 0 11-8 8 8.01 8.01 0 018-8m0-2a10 10 0 1010 10A10 10 0 0012 2z"
  })));
};
export default SvgSegStandardTier;